export const languageStringsContact = {
  title: "Kapcsolattartási adatok",
  basic: {
    title: "Alapadatok",
    accountType: "Fiók típusa",
    personal: "Személyes",
    business: "Vállalkozói",
    name: "Keresztnév",
    surname: "Vezetéknév",
    phone: "Telefonszám",
    dic: "Adószám",
    ico: "Cégjegyzékszám",
    companyName: "Cégnév",
  },
  address: {
    title: "Cím",
    street: "Utca és házszám",
    city: "Város",
    zip: "Irányítószám",
    country: "Ország",
    state: "Állam",
    czechRepublic: "Cseh Köztársaság",
    slovakia: "Szlovákia",
    hungary: "Magyarország",
    polish: "Lengyelország",
  },
};
